import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { getPlanList } from "../../../../apis/options/PlanApi";

/* 
    interim component to abstract away the calling of
    plans in case the page needs a default plan to be selected. It
    was getting confusing without it. Now I can always assume PlanDetails
    is receiving a Plan Id and load accordingly on the other end.
*/

const PlanDetailsDefault = _ => {

    const history = useHistory();

    useEffect(() => {
        async function fetchDefaultPlan() {
            const menu = await getPlanList();
            const sortedMenu = menu.sort((a,b) => new Date(b.startDate) - new Date(a.startDate));
            const planId = sortedMenu[0].planId; //problematic if there are no plans in the db!
            
            history.push(`/options/plans/${planId}`);
        }

        fetchDefaultPlan();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history]);

    return null;
    
}

export default PlanDetailsDefault;